import { useLayoutEffect, useState } from 'react';

export type RefWithElementCurrent<T extends HTMLElement = HTMLElement> = {
  readonly current: T | null;
};

export const useIsElementTall = (
  ref: RefWithElementCurrent<HTMLElement>,
  offset = 64,
) => {
  const [isTall, setIsTall] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const update = () => {
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      setIsTall(element.offsetHeight >= viewportHeight - offset);
    };
    update();
    window.addEventListener('resize', update);

    const observer =
      'ResizeObserver' in window ? new ResizeObserver(update) : null;

    observer?.observe(element);

    return () => {
      window.removeEventListener('resize', update);
      observer?.disconnect();
    };
  }, [ref, offset]);

  return isTall;
};
